import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardHeader, CardContent, Divider, Typography } from '@mui/material';

const OverviewCard = ({ header, headerVariant, children }) => (
  <Card variant="outlined" style={{ flex: 'auto', height: '100%' }}>
    <Box style={{ backgroundColor: '#f0f3f5' }}>
      <CardHeader title={<Typography variant={headerVariant || 'h5'}>{header}</Typography>} />
    </Box>
    <Divider />
    <CardContent>{children}</CardContent>
  </Card>
);

OverviewCard.propTypes = {
  header: PropTypes.string.isRequired,
  headerVariant: PropTypes.string,
  children: PropTypes.element,
};

export default OverviewCard;
